export default function onClick(e) {
  var swiper = this;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/events/onClick.js
// module id = 1154
// module chunks = 168